export const selectAddressApiToken = state => state.addressApi.token;
